import React, { Component } from 'react';

import './Support.scss'

class Contact extends Component {
  render() {
    return (
      <div className="landing container">
        <div className="row">
          <div className="col-12">
              <h1>Campaign Support</h1>
              <div className="row">
                  <div className="col-8">
                      <div className="card">
                          <div className="SupportBox">
                            <code>ADD INTERCOM FORM IN HERE</code>
                          </div>
                      </div>
                  </div>
                  <div className="col-4">
                      <div className="experProfile card">
                          <img src="https://randomuser.me/api/portraits/men/75.jpg" />
                          <h4>Rishi Ranjan</h4>
                          <p>Expert in the following:</p>
                          <ul>
                              <li>Building Campaigns</li>
                              <li>Smashing CPA'S</li>
                              <li>Converting all....!</li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
